import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_root/root-user/")({
  component: () => <Navigate to="/root-user/dashboard" />,
});
